import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  ApprovalStatusFilter,
  ClientApprovalStatusFilter,
  InvoicedFilter,
  TimeBillableTypeFilter,
  TimeOffTypeFilter,
} from '~/components';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function TimeFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      createdPeriod:
        sticky?.includes('createdPeriod') || Boolean(filters.createdPeriod?.start || filters.createdPeriod?.end),
      modifiedPeriod:
        sticky?.includes('modifiedPeriod') || Boolean(filters.modifiedPeriod?.start || filters.modifiedPeriod?.end),
      timeBillableTypes: isVisible('timeBillableTypes'),
      timeOffTypes: isVisible('timeOffTypes'),
      timeApprovalStatuses: isVisible('timeApprovalStatuses'),
      timeClientApprovalStatuses: isVisible('timeClientApprovalStatuses'),
      timeInvoiced: isVisible('timeInvoiced'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.createdPeriod && (
        <ReportPeriodFilter
          placeholder="Created Date Range"
          value={filters.createdPeriod}
          onChange={({ value }) => onChange({ createdPeriod: value })}
        />
      )}

      {visible.modifiedPeriod && (
        <ReportPeriodFilter
          placeholder="Modified Date Range"
          value={filters.modifiedPeriod}
          onChange={({ value }) => onChange({ modifiedPeriod: value })}
        />
      )}

      {visible.timeBillableTypes && (
        <TimeBillableTypeFilter
          value={filters.timeBillableTypes}
          onChange={({ target: { value } }) => onChange({ timeBillableTypes: value })}
        />
      )}

      {visible.timeOffTypes && (
        <TimeOffTypeFilter
          value={filters.timeOffTypes}
          onChange={({ target: { value } }) => onChange({ timeOffTypes: value })}
        />
      )}

      {visible.timeApprovalStatuses && (
        <ApprovalStatusFilter
          value={filters.timeApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ timeApprovalStatuses: value })}
        />
      )}

      {visible.timeClientApprovalStatuses && (
        <ClientApprovalStatusFilter
          value={filters.timeClientApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ timeClientApprovalStatuses: value })}
        />
      )}

      {visible.timeInvoiced && (
        <InvoicedFilter
          value={filters.timeInvoiced}
          onChange={({ target: { value } }) => onChange({ timeInvoiced: value })}
        />
      )}
    </>
  );
}
